import React from "react";
import AppLayoutAssistant from "../../../navigation/Layout/LayoutAssistant";
import useAssistantDoctorId from "../../hooks/useAssistantDoctorId";
import CabinetDashboard from "../../../cabinetDashboard/pages/CabinetDashboard/CabinetDashboard";

export default function AssistantCabinetDashboard() {
  const doctorId = useAssistantDoctorId();

  return (
    <CabinetDashboard
      LayoutComponent={AppLayoutAssistant}
      medecinIdOverride={doctorId}
    />
  );
}